import React from 'react';
import Icon from './Icon';

const UnderConstructionIcon = (props) => (
    <Icon {...props}>
        <path
            d="M7 17H11M9 17V8M6 8.5H16.5M14.5 8.5V12M13 12H16V15H13ZM9.5 2.4A10 10 0 1 1 2.4 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default UnderConstructionIcon;
